const modules = ["Sites", "Areas", "Checks", "Issues", "Activity"] as const;

export function App() {
  return (
    <main>
      <h1>FieldOps</h1>
      <nav>
        <ul>
          {modules.map((m) => (
            <li key={m}>{m}</li>
          ))}
        </ul>
      </nav>
    </main>
  );
}
